import * as React from 'react';
import ListItem from 'material-ui/List/ListItem';
import AvatarPlus from "../common/AvatarPlus";

interface IListItemPlusProps {
    src : string;
    size : number;
    displayName: string;
    itemClick(name : string) : void;
}

class ListItemPlus extends React.Component<IListItemPlusProps, any> {
    constructor(props : IListItemPlusProps) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.itemClick(this.props.displayName);
    }

    render() {

        const size = this.props.size;
        const name = this.props.displayName || 'unknown user';

        const avatar = (
            <div>
                <AvatarPlus
                    size={size}
                    src={this.props.src}
                />
            </div>
        );

        return (
            <div onClick={this.handleClick}>
                <ListItem
                    disabled={false}
                    leftAvatar={avatar}>
                    {name}
                </ListItem>
            </div>
        );

    }
}

export default ListItemPlus;



// WEBPACK FOOTER //
// ./components/voters/ListItemPlus.tsx